<svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" fill="currentColor" viewBox="0 0 24 24">
  <g clip-path="url(#a)">
    <path fill-rule="evenodd" d="M8.5 9.5C8.5 7.57 10.07 6 12 6s3.5 1.57 3.5 3.5S13.93 13 12 13s-3.5-1.57-3.5-3.5Zm2 0c0 .83.67 1.5 1.5 1.5s1.5-.67 1.5-1.5S12.83 8 12 8s-1.5.67-1.5 1.5Z" clip-rule="evenodd"/>
    <path fill-rule="evenodd" d="M2 12C2 6.48 6.48 2 12 2s10 4.48 10 10-4.48 10-10 10S2 17.52 2 12Zm10 5c-1.74 0-3.34.56-4.65 1.5 1.31.94 2.91 1.5 4.65 1.5 1.74 0 3.34-.56 4.65-1.5A7.941 7.941 0 0 0 12 17Zm0-2c2.32 0 4.45.8 6.14 2.12A7.957 7.957 0 0 0 20 12c0-4.42-3.58-8-8-8s-8 3.58-8 8c0 1.95.7 3.73 1.86 5.12A9.947 9.947 0 0 1 12 15Z" clip-rule="evenodd"/>
  </g>
  <defs>
    <clipPath id="a">
      <path d="M0 0h24v24H0z"/>
    </clipPath>
  </defs>
</svg>
